import type { MenuLink } from '@/constant/types'

export const EVENTS = {
  albumNext: 'album-next',
  albumPrev: 'album-prev',
}

export const PAGES = {
  home: {
    slug: '',
    type: 'home',
  },
  albums: {
    slug: 'albums',
    type: 'albumOverview',
  },
  album: {
    slug: 'albums',
    type: 'album',
  },
  albumsOverviewPrivate: {
    slug: 'a',
    type: 'albumsOverviewPrivate',
  },
  albumPrivate: {
    slug: 'album-private',
    type: 'albumPrivate',
  },
  photodiary: {
    slug: 'diary',
    type: 'photodiary',
  },
  china: {
    slug: 'china',
    type: 'china',
  },
} as const

export const MENU_LINKS: MenuLink[] = [
  { href: '/', label: 'Portfolio', description: 'Some highlights' },
  {
    href: `/${PAGES.albums.slug}`,
    label: 'Albums',
    description: 'Photos in groups',
  },
  {
    href: `/${PAGES.china.slug}`,
    label: 'China',
    description: 'Photos from Peru',
  },
  {
    href: `/${PAGES.photodiary.slug}/when-the-eagle-ate-the-snake`,
    label: 'When the eagle ate the snake',
    description: 'A photodiary from Mexico',
  },
  {
    href: `/${PAGES.photodiary.slug}/blessings-of-velocity`,
    label: 'Blessings of Velocity',
    description: 'A photodiary from the USA',
  },
  {
    href: 'https://sspp.benjaminelwyn.com',
    label: 'The Standing Streaming Primal Present',
    description: 'The World',
  },
] as const
